<template>
  <a href="#" class="cta">Request Invite</a>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.cta {
	background-image: var(--linearGradient);
	padding: 0.6em 1.4em;
	border-radius: 50px;
	color: #fff;
	font-size: 0.95rem;
	transition: all .3s linear;
  &:hover {
	opacity: .7;
}
}
</style>